import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Modal } from '@survio/ui';
import Iframe from './components/Iframe';

const InAppModal = ({ onClose, url, language }) => (
	<Modal slide="iframe" close={onClose}>
		{(slide) => {
			switch (slide) {
				case 'iframe':
					return <Iframe url={url} language={language} />;
			}
		}}
	</Modal>
);

InAppModal.propTypes = {
	onClose: PropTypes.func.isRequired,
	url: PropTypes.string.isRequired,
	language: PropTypes.string.isRequired,
};

export default memo(InAppModal);
